<!-- 召回通知单审核 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <subComponents ref="showSelectData"></subComponents>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border @selection-change="handleSelectionChange" style="width: 100%"
                highlight-current-row>
                <el-table-column type="selection" width="40">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                    v-if="tableValye.isShow == 1"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                 <span v-else-if="tableValye.fieldType == 'formatter'">
                            {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel"
                :parentSearchData="parentSearchData" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },

            buttonList: [],

            selectedDataIndex: 0,
            pageShowData: [],

            formDataList: {},
            selectVal: [],
            DialogVisible: false,
            formDataList: {},
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
            seId: ""
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            // if (type=='bgmId') {
            // 	this.parentSearchData["bgmName"]=this.getRequestData["bgmName"]
            // }else{
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
            // }
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;

                if (this.seType == "bgmId") {
                    this.getRequestData.bgmId = val.bgmId;
                    this.getRequestData.bgmName = val.bgmName;
                } else {
                    this.paramValue(val)
                }
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        handleSelectionChange(val) {
            this.selectVal = val
        },


        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path);
            this.getDataTest(ss.jurId);
        },

        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList[0]
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            if (this.selectVal.length == 0) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            switch (actionData.actionType) {
                case 4:
                    var arr = []
                    this.selectVal.forEach(item => {
                        arr.push(item.id)
                    })
                    this.$refs["processAuditAction"].openBox(0, arr);
                    break;
                case 5:
                    if (this.selectVal.length > 1) {
                        this.$message({
                            message: "请勾选一条数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["processAuditAction"].openBox(1, this.selectVal[0].id);
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.creditApplyqueryCreditApplyTask(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>